// extracted by mini-css-extract-plugin
module.exports = {"rating":"Cf-z","numberOfStars":"Df-z","count":"Ef-z"};